/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/theater/showtimes/chainListOverlay.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'theater/showtimes/chainListOverlay', exports: {} };
const exports = module.exports;



import { Fandango as Fandango_context } from '@take-2/fd-modules/splits/require-core';

const { context } = Fandango_context;


import { global_consts as global_consts_QueryParams } from '@take-2/fd-modules/splits/require-core';

const { QueryParams } = global_consts_QueryParams;


import $ from '@take-2/fd-modules/jQuery';



import { Fandango_Dialog as Dialog } from '@take-2/fd-modules/splits/require-global';



import { Fandango_queryUtil as queryUtil } from '@take-2/fd-modules/splits/require-core';



import { Fandango_util as util } from '@take-2/fd-modules/splits/require-global';



import openChainFilter from '@take-2/fd-modules/theater/showtimes/openChainFilterDesktop';



const { chainID } = readPageContext(context)


const Selectors = {
    CHAIN_LIST_OVERLAY: '#chain-list-overlay',
    CANCEL_BTN: '#chain-list-overlay-cancel-btn',
    FORM: '#tsp-chain-list-selection-form',
    RADIO_BTNS: '.js-chain-list-overlay-radio',
    RESET_BTN: '#chain-list-overlay-reset-btn',
    // #region Radio Btn prefix
    RADIO_BTN_PREFIX: '#tsp-chain-input--',
    RADIO_BTN_LABEL_PRREFIX: '#tsp-chain-label--',
    // #endregion
}


const Styles = {
    SELECTED_LABEL: 'chain-list-popup__label--selected'
}


const KeyCodes = {
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
}


const DataAttributes = {
    CHECKED: 'checked'
}


const EventNames = {
    CLOSE: 'close',
    KEYDOWN: 'keydown',
    SUBMIT: 'submit',
}


const SatelliteEvents = {
    EXHIBITOR_CLICK: 'filter exhibitor selected clicks',
    OPEN_FILTER: 'filter exhibitor clicks',
}


let keyboardAccess = false


let initialChainID


let selectedChainID
function readPageContext(context) {
    return {
        chainID: context.theater.chainID
    };
}
function filterBySelectedChain() {
    if (selectedChainID === initialChainID) {
        return;
    }
    util.track(SatelliteEvents.EXHIBITOR_CLICK, { exhibitorSelected: selectedChainID });
    util.navigate(window.location.pathname + '?' + queryUtil.setParam(QueryParams.CHAIN_ID, selectedChainID));
}
function onClick(e) {
    selectedChainID = e.currentTarget.dataset.chainId;
    if (keyboardAccess) {
        return;
    }
    filterBySelectedChain();
}
function onKeyDown(e) {
    const key = e.keyCode;
    if (key >= KeyCodes.ARROW_LEFT && key <= KeyCodes.ARROW_DOWN) {
        keyboardAccess = true;
    }
}
function onReset() {
    util.navigate(window.location.pathname + queryUtil.removeParam(QueryParams.CHAIN_ID));
}
function onClose() {
    $(Selectors.CHAIN_LIST_OVERLAY).off(EventNames.KEYDOWN, onKeyDown);
    openChainFilter.onOverlayClose();
}
function show() {
    const overlay = new Dialog(Selectors.CHAIN_LIST_OVERLAY);
    initialChainID = chainID;
    keyboardAccess = false;
    function onCancel() {
        overlay.close();
    }
    function onSubmit(e) {
        e.preventDefault();
        if (selectedChainID && selectedChainID !== initialChainID) {
            filterBySelectedChain();
        }
        else {
            overlay.close();
            $(Selectors.FORM).off(EventNames.SUBMIT, onSubmit);
        }
    }
    $(Selectors.FORM).on('submit', onSubmit);
    $(Selectors.CANCEL_BTN).on('click', onCancel);
    $(Selectors.RESET_BTN).on('click', onReset);
    $(Selectors.RADIO_BTNS).on('click', onClick);
    $(Selectors.RADIO_BTN_PREFIX + initialChainID).attr(DataAttributes.CHECKED, 'true');
    $(Selectors.RADIO_BTN_LABEL_PRREFIX + initialChainID).addClass(Styles.SELECTED_LABEL);
    overlay.on(EventNames.CLOSE, onClose);
    $(Selectors.CHAIN_LIST_OVERLAY).on('keydown', onKeyDown);
    overlay.open();
    util.track(SatelliteEvents.OPEN_FILTER);
}
export default {
    show,
};
